import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  Box,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { fetchActiveBatchesAPI } from '../Dashboard/dashboardAPI';
import { useStyles } from './ActiveBatchesModalStyles';

const ActiveBatchesModal = ({ open, onClose, cmoSite, deliverableType }) => {
  const classes = useStyles();
  const [activeBatches, setActiveBatches] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch active batches when modal opens
  useEffect(() => {
    if (open) {
      const fetchActiveBatches = async () => {
        try {
          setLoading(true);
          const response = await fetchActiveBatchesAPI({
            cmoSite: cmoSite || 'all',
            deliverableType: deliverableType || 'all',
          });

          if (response?.status && response?.data?.activeBatches) {
            setActiveBatches(response.data.activeBatches);
          } else {
            setActiveBatches([]);
          }
        } catch (error) {
          console.error('Error fetching active batches:', error);
          setActiveBatches([]);
        } finally {
          setLoading(false);
        }
      };

      fetchActiveBatches();
    } else {
      // Reset data when modal closes
      setActiveBatches([]);
    }
  }, [open, cmoSite, deliverableType]);

  const data = activeBatches;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" className={classes.dialog}>
      <DialogTitle className={classes.dialogTitle}>
        <Typography className={classes.title}>View Active Batches</Typography>
        <div className={classes.closeButton} onClick={onClose}>
          <Typography className={classes.closeText}>Close</Typography>
          <CloseIcon className={classes.closeIcon} />
        </div>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer component={Paper} className={classes.tableContainer} elevation={0}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell align="left" className={classes.headerCell}>Batch Number</TableCell>
                  <TableCell align="left" className={classes.headerCell}>CMO - Site</TableCell>
                  <TableCell align="left" className={classes.headerCell}>
                    Project ID / Product Description
                  </TableCell>
                  <TableCell align="left" className={classes.headerCell}>
                    CMO Stage
                    <br />
                    (Chemical Number)
                  </TableCell>
                  <TableCell align="left" className={classes.headerCell}>Latest Update</TableCell>
                  <TableCell align="left" className={classes.headerCell}>Timestamp</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.length > 0 ? (
                  data.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="left" className={classes.tableCell}>
                        {row.batchNumber}
                      </TableCell>
                      <TableCell align="left" className={classes.tableCell}>
                        {row.cmoSite}
                      </TableCell>
                      <TableCell align="left" className={classes.tableCell}>
                        {row.projectId} / {row.productDescription}
                      </TableCell>
                      <TableCell align="left" className={`${classes.tableCell} ${classes.multiLineCell}`}>
                        {row.cmoStage}
                        <br />
                        {row.chemicalNumber}
                      </TableCell>
                      <TableCell align="left" className={`${classes.tableCell} ${classes.multiLineCell}`}>
                        Completed: {row.completed}
                        <br />
                        Ongoing: {row.ongoing}
                        <br />
                        On Hold / Discontinued: {row.onHold || ''}
                      </TableCell>
                      <TableCell align="left" className={classes.tableCell}>
                        {row.timestamp}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} align="center" className={classes.tableCell}>
                      <Typography>No active batches found</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ActiveBatchesModal;

